var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.916 0a2.728 2.728 0 0 1 2.721 2.719v19.56A2.73 2.73 0 0 1 12.917 25H2.72A2.728 2.728 0 0 1 0 22.279V2.72A2.726 2.726 0 0 1 2.719 0zm0 2.04H2.72a.684.684 0 0 0-.68.681V22.28a.684.684 0 0 0 .68.68h10.196a.684.684 0 0 0 .68-.681V2.72a.684.684 0 0 0-.68-.68zm-7.681 8.552.113.009a.72.72 0 0 1 .47.292l.891 1.267a.713.713 0 0 1-.171.991l-.379.268a.126.126 0 0 0-.036.167 5.86 5.86 0 0 0 2.136 2.141.13.13 0 0 0 .16-.03l.35-.421a.71.71 0 0 1 .949-.134l1.226.837a.713.713 0 0 1 .236.906l-.292.585a.917.917 0 0 1-.694.5c-1.291.09-2.691-.173-4.68-2.506l-.037-.039c-.265-.277-1.792-1.97-1.613-3.629.006-.486.622-.796.946-1.064a.719.719 0 0 1 .538-.131zm2.898-.689a3.66 3.66 0 0 1 3.655 3.657.473.473 0 1 1-.947 0 2.712 2.712 0 0 0-2.708-2.709.474.474 0 0 1 0-.948zm0 1.36a2.298 2.298 0 0 1 2.295 2.296.474.474 0 0 1-.948 0 1.35 1.35 0 0 0-1.347-1.348.473.473 0 1 1 0-.948zm.013-8.36a.595.595 0 1 1 0 1.19H5.927a.595.595 0 1 1 0-1.19zm1.662 0a.595.595 0 1 1 0 1.19h-.073a.595.595 0 1 1 0-1.19z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportPhone);
export default __webpack_public_path__ + "static/media/support_phone.adc8210a9018874cf8d386564fb14d20.svg";
export { ForwardRef as ReactComponent };